import { URLS } from '~types/Urls.types';

import { McsApiLoader, McsApiService } from './types';

declare global {
  interface Window {
    __mcsApiWrapper__?: McsApiService;
    __mcsApi__?: McsApiLoader;
  }
}

export const McsApi = {
  loadApi(): Promise<McsApiService> {
    return new Promise((resolve, reject) => {
      const CHECK_INTERVAL = 100;
      const MAX_WAITING_TIME = 65000;
      const CHECKING_START_TIME = Date.now();
      let pending = false;

      (function check() {
        if (!pending && window.__mcsApi__ && window.__mcsApi__.ready) {
          pending = true;
          window.__mcsApi__
            .ready()
            // @ts-expect-error __mcsApiWrapper must exist
            .then(() => resolve(window.__mcsApiWrapper__));
        }

        if (Date.now() - CHECKING_START_TIME > MAX_WAITING_TIME) {
          reject(new Error('not ready __mcsApi__'));

          return;
        }

        window.setTimeout(check, CHECK_INTERVAL);
      })();
    });
  },
  async getApi(): Promise<McsApiService> {
    if (window.__mcsApi__?.isReady && window.__mcsApiWrapper__) {
      return window.__mcsApiWrapper__;
    }

    return await this.loadApi();
  },
  async signIn(onSuccess?: () => void) {
    try {
      const api = await this.getApi();

      return await api.signIn(onSuccess);
    } catch (error) {
      window.location.href = URLS.AppSignIn;
    }
  },
  async renderSignInTo({
    element,
    hideSignUp,
  }: {
    element: Element;
    hideSignUp: boolean;
  }) {
    try {
      const api = await this.getApi();

      return api.renderSignInTo(element, hideSignUp);
    } catch (error) {
      window.location.href = URLS.AppSignIn;
    }
  },
  async renderSignUpTo({
    element,
    hideSignUp,
  }: {
    element: Element;
    hideSignUp: boolean;
  }) {
    try {
      const api = await this.getApi();

      return api.renderSignUpTo(element, hideSignUp);
    } catch (error) {
      window.location.href = URLS.AppSignUp;
    }
  },
  async signUp(onSuccess?: () => void) {
    try {
      const api = await this.getApi();

      if (window.__mcsApi__?.isScriptSetuped) {
        return await api.signUp(onSuccess);
      } else {
        window.location.href = URLS.AppSignUp;
      }
    } catch (error) {
      window.location.href = URLS.AppSignUp;
    }
  },
  async signOut() {
    try {
      const api = await this.getApi();

      return await api.signOut();
    } catch (error) {
      window.location.href = URLS.AppSignOut;
    }
  },
  async getUser() {
    const api = await this.getApi();

    return api.user;
  },
};
